import { render, staticRenderFns } from "./CatalogItemInfo.vue?vue&type=template&id=eeb01750&"
import script from "./CatalogItemInfo.vue?vue&type=script&lang=js&"
export * from "./CatalogItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItemInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports